import { render } from "./RTPagination.vue?vue&type=template&id=dfd6fa38"
import script from "./RTPagination.vue?vue&type=script&lang=js"
export * from "./RTPagination.vue?vue&type=script&lang=js"

import exportComponent from "/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__